exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".navbar-nav.selectedGroup a.dropdown-toggle .profileImage{height:35px;width:35px;line-height:35px;position:absolute;top:7px}.navbar-nav.selectedGroup a.dropdown-toggle .profileImage~.text{padding-left:40px}", "", {"version":3,"sources":["C:/Users/fpluq/Projects/groopus-vue/src/components/MainWrapper/HeaderGroupSelection.vue"],"names":[],"mappings":"AACA,0DACE,YAAa,AACb,WAAY,AACZ,iBAAkB,AAClB,kBAAmB,AACnB,OAAS,CACV,AACD,gEACI,iBAAmB,CACtB","file":"HeaderGroupSelection.vue","sourcesContent":["\n.navbar-nav.selectedGroup a.dropdown-toggle .profileImage {\n  height: 35px;\n  width: 35px;\n  line-height: 35px;\n  position: absolute;\n  top: 7px;\n}\n.navbar-nav.selectedGroup a.dropdown-toggle .profileImage ~ .text {\n    padding-left: 40px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-625b49a8","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MainWrapper/HeaderGroupSelection.vue
// module id = 1087
// module chunks = 1